import { render, staticRenderFns } from "./zoonHeader.vue?vue&type=template&id=187a2944&scoped=true"
import script from "./zoonHeader.vue?vue&type=script&lang=js"
export * from "./zoonHeader.vue?vue&type=script&lang=js"
import style0 from "./zoonHeader.vue?vue&type=style&index=0&id=187a2944&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.4.27_babel-core@6.26.3_css-loader@6.11.0_webpack@5.92._4ybukp33xmar2t4t23nvjqqetu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187a2944",
  null
  
)

export default component.exports